import apiInstance from "./api";

export const getSeasons = async () => {
	return apiInstance.get(`/seasons`);
};

export const createSeason = async (season) => {
	return apiInstance.post(`/seasons`, season);
};

export const updateSeason = async (seasonId, season) => {
	return apiInstance.put(`/seasons/${seasonId}`, season);
};

export const addSeasonToAllLeagues = async (seasonId) => {
	return apiInstance.post(`/seasons/${seasonId}/league`);
};

export const addSeasonToAllEvents = async (seasonId) => {
	return apiInstance.post(`/seasons/${seasonId}/event`);
};

export const addSeasonToAllTeams = async (seasonId) => {
	return apiInstance.post(`/seasons/${seasonId}/team`);
};

export const getCurrentSeason = async () => {
	return apiInstance.get(`/seasons/current/season`);
};
